import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { createCommentApi, getCommentsApi } from '../../api/comment.api';
import { showSignInPopup } from '../../redux/auth.slice';
import { compareDate } from '../../utils/compare';
import { toastStyle } from '../../configs/toastStyleConfig';
import Reviews from '../../components/RecipeDetailComponent/Reviews';

const ReviewContainer = ({ recipe, toast, toggleScroll }) => {
    const [comment, setComment] = useState('');
    const [comments, setComments] = useState([]);
    const [currentUserList, setCurrentUserList] = useState([]);
    const [otherUserList, setOtherUserList] = useState([]);
    const currentUser = useSelector(state => state.auth.signIn.currentUser);
    const dispatch = useDispatch();
    let commentValid = comment.trim().length;

    const handleChangeComment = (event) => {
        setComment(event.target.value);
    }

    const getComments = (recipe) => {
        getCommentsApi(recipe.id)
            .then(res => {
                const list = [...res.data];
                let list1 = new Set();
                let list2 = new Set();

                list.forEach(element => {
                    if (currentUser?.id === element.user.id) {
                        list1.add(element)
                    } else {
                        list2.add(element)
                    }
                });

                setComments([...list].sort(compareDate("updateDate", "desc")))
                setCurrentUserList([...list1].sort(compareDate("updateDate", "desc")))
                setOtherUserList([...list2].sort(compareDate("updateDate", "desc")))
            })
            .catch(err => {
                console.log(err)
            })
    }

    async function handleSubmitComment(e) {
        e.preventDefault();
        if (currentUser) {
            const data = {
                userId: currentUser.id,
                recipeId: recipe.id,
                comment: comment
            };

            await createCommentApi(data, currentUser.token)
                .then(res => {
                    if (res.data === "This comment already existed!") {
                        toast.error('You have commented before!', toastStyle);
                    } else {
                        toast.success('Comment successfully!');
                    }
                })
                .then(() => {
                    getComments(recipe);
                })
                .catch(err => {
                    toast.error('Comment Failed!');
                })
        } else {
            dispatch(showSignInPopup());
        }
        setComment('');
    }

    useEffect(() => {
        recipe && getComments(recipe);
    }, [recipe, currentUser])

    return (
        <Reviews
            comment={comment}
            commentValid={commentValid}
            comments={comments}
            currentUserList={currentUserList}
            handleChangeComment={handleChangeComment}
            handleSubmitComment={handleSubmitComment}
            otherUserList={otherUserList}
            recipe={recipe}
            toggleScroll={toggleScroll}
        />
    )
}

export default ReviewContainer